export default __webpack_public_path__ + "static/media/background.3d6842ae.svg";